module.exports = __webpack_public_path__ + "img/icon-error.f2cf56a6.png";